module.exports = __webpack_public_path__ + "21c3c8f10e3e1ae46ec3ad3dd87b2ff7.svg";